import React, { useContext, useState } from 'react'
import { FormLayoutRow } from '@pushly/aqe/lib/components'
import { Input, Typography } from 'antd'
import { PromptVisitorConditions } from '@pushly/models/lib/structs/prompts/prompt-visitor-conditions'
import { DEFAULT_SCROLL_DEPTH } from '../../constants'
import { PromptEditorContext } from '../../context'

type Props = {
    value: PromptVisitorConditions | undefined
    onChange: (update: PromptVisitorConditions) => void
}

export const ScrollDepthConditionEditor: React.FC<Props> = ({ value, onChange }) => {
    const { loading, selectedPromptIdx } = useContext(PromptEditorContext)

    const [scrollDepthPct, setScrollDepthPct] = useState<number>(value?.scrollDepthPct ?? DEFAULT_SCROLL_DEPTH)

    return (
        <FormLayoutRow
            loading={loading}
            layout="vertical"
            label={null}
            value={
                !loading && (
                    <>
                        <Input
                            key={selectedPromptIdx}
                            placeholder={`${DEFAULT_SCROLL_DEPTH}`}
                            addonAfter="% of page scrolled"
                            className="vc-scroll-depth"
                            type="number"
                            min={1}
                            max={100}
                            defaultValue={value?.scrollDepthPct ?? DEFAULT_SCROLL_DEPTH}
                            onChange={(ev) => {
                                const nextValue = parseInt(ev.target.value, 10)
                                setScrollDepthPct(nextValue)
                                onChange(
                                    PromptVisitorConditions.from({
                                        scrollDepthPct: nextValue,
                                    }),
                                )
                            }}
                        />
                        <Typography.Paragraph type="secondary" className="text--size--small">
                            Shows to users who have scrolled down at least {Number.isNaN(scrollDepthPct) ? 0 : scrollDepthPct}% of the page.
                        </Typography.Paragraph>
                    </>
                )
            }
        />
    )
}
